import { render } from "./Support.vue?vue&type=template&id=0ebde70d&scoped=true"
import script from "./Support.vue?vue&type=script&lang=ts"
export * from "./Support.vue?vue&type=script&lang=ts"

import "./Support.vue?vue&type=style&index=0&id=0ebde70d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0ebde70d"

export default script